var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutletIcon7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4504,
    cy: 11.9499,
    r: 6.05,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.899902C16.8302 0.899902 21.5 5.30233 21.5 10.6538C21.4999 12.8391 20.8386 15.2614 19.8203 17.687C18.804 20.108 17.4444 22.5024 16.0791 24.6235C14.7146 26.7434 13.3497 28.5824 12.3252 29.8911C11.8131 30.5452 11.3867 31.0664 11.0889 31.4233C11.0581 31.4602 11.0279 31.4945 11 31.5278C10.9721 31.4945 10.9419 31.4602 10.9111 31.4233C10.6133 31.0664 10.1869 30.5452 9.6748 29.8911C8.65027 28.5824 7.28542 26.7434 5.9209 24.6235C4.55556 22.5024 3.19601 20.108 2.17969 17.687C1.16145 15.2614 0.500067 12.8391 0.5 10.6538C0.5 5.30233 5.1698 0.899902 11 0.899902ZM12.8809 7.12256C11.9835 6.73764 10.9949 6.63705 10.041 6.8335C9.08717 7.03 8.21335 7.5147 7.5293 8.22314C6.84547 8.93139 6.38116 9.83153 6.19336 10.8091C6.00562 11.7866 6.10206 12.8003 6.4707 13.7222C6.83938 14.644 7.46478 15.4349 8.27051 15.9927C9.07669 16.5506 10.0269 16.8501 11 16.8501H11.001C12.3056 16.8485 13.5528 16.3106 14.4697 15.3608C15.3861 14.4117 15.8989 13.1284 15.9004 11.7935V11.7925C15.9003 10.7962 15.6152 9.82076 15.0791 8.98975C14.5428 8.15845 13.7782 7.50751 12.8809 7.12256Z",
    fill: "#1E49B9",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.6123L13.7124 15.0747",
    stroke: "#1E49B9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7124 9.6123L8.25 15.0747",
    stroke: "#1E49B9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutletIcon7);
export default __webpack_public_path__ + "static/media/OutletIcon7.a12b52ad55ac622968cab690aafa2d8e.svg";
export { ForwardRef as ReactComponent };